export default {
  // for string property, default view is input[type=text]
  control: 'text',
  showHint: false,
  valueUpdate: 'input',
  validators: {
    maxLength: { blockInput: false /*, message */ },
  },
};
